// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal-module--Modal--3K7IZ","ModalWrapper":"Modal-module--ModalWrapper--1i6KL"};